import { classApi } from '@/api'
import { IEnrollmentProfileData } from '../../CourseEnrollmentModal/utils/api'

interface ClassEnrollParams {
  totalPrice: number
  firstPrice?: number | null
  classId?: number
  linkId?: number
  value?: number
  promo?: IPromoCodeDiscount | null
  user?: IEnrollmentProfileData
  token?: string
  code?: string
  userAlreadyExists?: boolean
  userId?: number
  price: number
  discount: number
}

export const classEnrollment = async ({
  totalPrice,
  firstPrice,
  classId,
  linkId,
  value,
  promo,
  user,
  token,
  code,
  userAlreadyExists,
  userId,
  price,
  discount,
}: ClassEnrollParams): Promise<{
  status: 'success' | 'error'
  data: PaymentOrder | null
}> => {
  try {
    const data = new FormData()
    if (classId) data.append('class_id', classId?.toString())
    if (linkId) data.append('link_id', linkId?.toString())
    if (value) data.append('value', value?.toString())
    if (promo?.id) data.append('promo_id', promo?.id?.toString())
    if (user) data.append('user', JSON.stringify(user))
    if (!!token) data.append('token', token?.toString())
    if (!!code) data.append('code', code?.toString())
    if (userAlreadyExists) data.append('userAlreadyExists', '1')
    data.append('amount', totalPrice.toString())
    data.append('price', price.toString())
    data.append('discount', discount.toString())
    if (userId) data.append('user_id', userId?.toString())
    if (firstPrice) data.append('first_price', firstPrice?.toString())

    const res = await classApi.enroll(data)

    return { status: res?.data.status, data: res?.data?.data ?? null }
  } catch (error) {
    console.error('Ошибка записи на класс:', error)
    return { status: 'error', data: null }
  }
}
